import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api'; // Your axios instance

const ResetPasswordConfirm = () => {
    const { uid, token } = useParams(); 
    const navigate = useNavigate();
    
    // 1. Add state for the second field & error handling
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors

        // 2. Client-side Validation
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return; // Stop here, do not call API
        }

        if (password.length < 8) {
            setError("Password must be at least 8 characters long.");
            return; 
        }

        try {
            await api.post('auth/reset-password/confirm/', { 
                uid, 
                token, 
                new_password: password 
            });
            alert("Password reset successful! Please log in.");
            navigate('/');
        } catch (err) {
            // Display backend error if available
            setError(err.response?.data?.error || "Error resetting password.");
        }
    };

    return (
        <div style={{ padding: '50px', color: 'white', maxWidth: '400px', margin: '0 auto' }}>
            <h2>Set New Password</h2>
            
            {/* Error Message Display */}
            {error && <div style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>New Password</label>
                    <input 
                        type="password" 
                        placeholder="Enter new password" 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '8px' }}
                    />
                </div>

                {/* 3. The Second Input Field */}
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Confirm Password</label>
                    <input 
                        type="password" 
                        placeholder="Retype password" 
                        value={confirmPassword} 
                        onChange={e => setConfirmPassword(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '8px' }}
                    />
                </div>

                <button type="submit" style={{ padding: '10px', cursor: 'pointer', marginTop: '10px' }}>
                    Set Password
                </button>
            </form>
        </div>
    );
};

export default ResetPasswordConfirm;